import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Filter, Target, ShieldAlert, PenTool, MessageSquare } from 'lucide-react';
const steps = [{
  icon: Filter,
  title: 'FILTRO',
  desc: 'Identificá en el primer mensaje si es un cliente real o un curioso.'
}, {
  icon: Target,
  title: 'FOCO',
  desc: 'Dirigí la conversación hacia lo que tu cliente necesita resolver.'
}, {
  icon: ShieldAlert,
  title: 'FRICCIÓN',
  desc: 'Anticipate a las objeciones antes de que aparezcan.'
}, {
  icon: PenTool,
  title: 'FIRMA',
  desc: 'Cerrá con un mensaje claro que invite a la acción.'
}, {
  icon: MessageSquare,
  title: 'FOLLOW-UP',
  desc: 'Hacé seguimiento sin vergüenza ni incomodidad.'
}];
export function MechanismSection() {
  return <Section background="white" data-id="element-67">
      <div className="text-center mb-16" data-id="element-68">
        <span className="text-[#C5A55A] font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-69">
          El Método Único
        </span>
        <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4" data-id="element-70">
          Presentamos el Mapa de Conversación 5F
        </h2>
        <p className="text-lg text-[#6B6B6B]" data-id="element-71">
          5 pasos para convertir cada consulta en una venta
        </p>
      </div>

      <div className="max-w-4xl mx-auto relative" data-id="element-72">
        {/* Vertical Line for Desktop */}
        <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-[#F5F0E8] -translate-x-1/2 hidden md:block" data-id="element-73" />

        <div className="space-y-8 md:space-y-0" data-id="element-74">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`flex flex-col md:flex-row items-center gap-6 md:gap-0 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-75">
              {/* Content Side */}
              <div className={`flex-1 text-center ${index % 2 !== 0 ? 'md:text-left md:pl-12' : 'md:text-right md:pr-12'}`} data-id="element-76">
                <h3 className="text-2xl font-serif font-bold text-[#2D2D2D] mb-2" data-id="element-77">
                  {step.title}
                </h3>
                <p className="text-[#6B6B6B]" data-id="element-78">{step.desc}</p>
              </div>

              {/* Center Icon */}
              <div className="relative z-10 flex-shrink-0 w-16 h-16 rounded-full bg-[#F5F0E8] border-4 border-white shadow-lg flex items-center justify-center text-[#C5A55A]" data-id="element-79">
                <step.icon size={28} strokeWidth={1.5} data-id="element-80" />
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-[#C5A55A] text-white rounded-full text-xs flex items-center justify-center font-bold" data-id="element-81">
                  {index + 1}
                </div>
              </div>

              {/* Empty Side for Balance */}
              <div className="flex-1 hidden md:block" data-id="element-82" />
            </motion.div>)}
        </div>
      </div>
    </Section>;
}